export default {
  slug: "dotcover",
  code: "DC",
  label: "dotCover",
  krakenDir: "dotCover",
  thumbnailColor: "#FC801D",
  logoFamily: "jb",
};
